import { memo, PropsWithChildren } from 'react';

function MarketSelectorTableCell({ children }: PropsWithChildren) {
	return (
		<span className="flex items-center justify-end text-right typo-body-xs md:typo-label-xs">
			{children}
		</span>
	);
}

export default memo(MarketSelectorTableCell);
